import { createRouter, createWebHistory } from 'vue-router';
import store from "../store";

// Auth
import Login from '../views/auth/Login';
import NotFound from '../views/NotFound';

// Dashboard
import Dashboard from '../views/dashboard/Dashboard';

// Franchise
import FranchiseDetail from '../views/dashboard/franchise/Detail';
import FranchiseReports from '../views/dashboard/franchise/Reports';

import ProfileDetail from '../views/dashboard/profile/Detail';

// Branches
import BranchesForm from '../views/dashboard/branches/Form';

// Ranges
import RangesIndex from '../views/dashboard/ranges/Index';

// Orders
import OrdersIndex from '../views/dashboard/orders/Index';

// Inventory
import InventoriesIndex from '../views/dashboard/inventories/Index';

// Clients
import ClientsIndex from '../views/dashboard/clients/Index';
import ClientsDetail from '../views/dashboard/clients/Detail';

// Quotes
import QuotesDetail from '../views/dashboard/quotes/Detail';
import QuotesIndex from '../views/dashboard/quotes/Index';

// Pets
import PetsIndex from '../views/dashboard/pets/Index';
import PetsDetail from '../views/dashboard/pets/Detail';
import PetCheckupsForm from '../views/dashboard/pets/CheckupForm';
import PetCommentsForm from '../views/dashboard/pets/CommentForm';

// Order Requests
import OrderRequestsIndex from '../views/dashboard/orderRequests/Index';
import OrderRequestsDetail from '../views/dashboard/orderRequests/Detail';

// Users
import UsersIndex from '../views/dashboard/users/Index';
import UsersForm from '../views/dashboard/users/Form';
import UsersDetail from '../views/dashboard/users/Detail';

// Roles
import RolesIndex from '../views/dashboard/roles/Index';
import RolesForm from '../views/dashboard/roles/Form';
import RolesDetail from '../views/dashboard/roles/Detail';

// Cart
import Cart from "../views/dashboard/cart/Cart";

// Products
import ProductsIndex from "../views/dashboard/products/Index";
import ProductsDetail from "../views/dashboard/products/Detail";

// Product Orders
import ProductOrdersIndex from '../views/dashboard/productOrders/Index';
import ProductOrdersDetail from '../views/dashboard/productOrders/Detail';

// Accounting
import AccountingIndex from '../views/dashboard/accounting/Index';
import IncomesIndex from '../views/dashboard/accounting/incomes/Index';
import IncomesForm from '../views/dashboard/accounting/incomes/Form';
import ExpensesIndex from '../views/dashboard/accounting/expenses/Index';
import ExpensesForm from '../views/dashboard/accounting/expenses/Form';

// Reports
import ReportsIndex from '../views/dashboard/reports/Index';
import Monthly from '../views/dashboard/reports/Monthly';
import Biweekly from '../views/dashboard/reports/Biweekly';

// Notifications
import NotificationsIndex from '../views/dashboard/notifications/Index';

// Production Schedule
import ProductionScheduleIndex from '../views/dashboard/productionSchedule/Index';

// Manual
import ManualIndex from '../views/dashboard/manual/Index';
import ManualGettingStarted from '../views/dashboard/manual/sections/GettingStarted';
import ManualOrders from '../views/dashboard/manual/sections/Orders';
import ManualProductionSchedule from '../views/dashboard/manual/sections/ProductionSchedule';
import ManualClients from '../views/dashboard/manual/sections/Clients';
import ManualPets from '../views/dashboard/manual/sections/Pets';
import ManualInventory from '../views/dashboard/manual/sections/Inventory';
import ManualUsers from '../views/dashboard/manual/sections/Users';
import ManualAccounting from '../views/dashboard/manual/sections/Accounting';
import ManualReports from '../views/dashboard/manual/sections/Reports';

const routes = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard/:branchId',
    name: 'dashboard',
    component: Dashboard,
    redirect: { name: 'profileDetail' },
    meta: { requiresLogin: true, requiresBranch: true },
    children: [
      {
        path: 'franquicia',
        name: 'franchise',
        redirect: { name: 'franchiseDetail' },
        meta: { permission: 'view_franchise', breadcrumb: { label: 'Franquicia' } },
        children: [
          {
            path: 'perfil',
            name: 'franchiseDetail',
            component: FranchiseDetail
          },

          {
            path: 'reportes',
            name: 'franchiseReports',
            component: FranchiseReports,
            meta: { breadcrumb: { label: 'Reportes' } },
          },
        ]
      },

      {
        path: 'perfil',
        name: 'profileDetail',
        component: ProfileDetail,
        meta: { breadcrumb: { label: 'Sucursal' } },
      },

      {
        path: 'notificaciones',
        name: 'notifications',
        component: NotificationsIndex,
        meta: { permission: 'view_notifications', breadcrumb: { label: 'Notificaciones' } },
      },

      {
        path: 'sucursales',
        name: 'branches',
        redirect: { name: 'branchesForm' },
        meta: { breadcrumb: { label: 'Sucursal' } },
        children: [
          {
            path: 'crear',
            name: 'branchesCreateForm',
            component: BranchesForm,
            meta: { breadcrumb: { label: 'Crear' } },
          },
          {
            path: 'editar/:id',
            name: 'branchesEditForm',
            component: BranchesForm,
            meta: { breadcrumb: { label: 'Editar' } },
          },
        ]
      },

      {
        path: 'rangos',
        name: 'ranges',
        redirect: { name: 'rangesIndex' },
        meta: { permission: 'view_ranges', breadcrumb: { label: 'Rangos de envío' } },
        children: [
          {
            path: '',
            name: 'rangesIndex',
            component: RangesIndex,
          }
        ]
      },

      {
        path: 'ordenes',
        name: 'orders',
        redirect: { name: 'ordersIndex' },
        meta: { permission: 'view_orders', breadcrumb: { label: 'Órdenes' } },
        children: [
          {
            path: '',
            name: 'ordersIndex',
            component: OrdersIndex,
          }
        ]
      },

      {
        path: 'programa-produccion',
        name: 'productionSchedule',
        redirect: { name: 'productionScheduleIndex' },
        meta: { permission: 'view_orders', breadcrumb: { label: 'Programa Producción' } },
        children: [
          {
            path: '',
            name: 'productionScheduleIndex',
            component: ProductionScheduleIndex,
          }
        ]
      },

      {
        path: 'inventario',
        name: 'inventories',
        redirect: { name: 'inventoriesIndex' },
        meta: { permission: 'view_inventories', breadcrumb: { label: 'Inventario' } },
        children: [
          {
            path: '',
            name: 'inventoriesIndex',
            component: InventoriesIndex,
          },
        ]
      },

      {
        path: 'clientes',
        name: 'clients',
        redirect: { name: 'clientsIndex' },
        meta: { permission: 'view_clients', breadcrumb: { label: 'Clientes' } },
        children: [
          {
            path: '',
            name: 'clientsIndex',
            component: ClientsIndex,
          },
          {
            path: ':id',
            name: 'clientsDetail',
            component: ClientsDetail,
            meta: { breadcrumb: { label: 'Cliente', dynamic: true } },
          },
        ]
      },

      {
        path: 'planes',
        name: 'quotes',
        redirect: { name: 'quotesIndex' },
        meta: { permission: 'view_quotes', breadcrumb: { label: 'Planes' } },
        children: [
          {
            path: '',
            name: 'quotesIndex',
            component: QuotesIndex,
          },
          {
            path: ':id',
            name: 'quotesDetail',
            component: QuotesDetail,
            meta: { breadcrumb: { label: 'Plan', dynamic: true } },
          }
        ]
      },

      {
        path: 'mascotas',
        name: 'pets',
        redirect: { name: 'petsIndex' },
        meta: { permission: 'view_pets', breadcrumb: { label: 'Mascotas' } },
        children: [
          {
            path: '',
            name: 'petsIndex',
            component: PetsIndex,
          },
          {
            path: ':id',
            name: 'petsDetail',
            component: PetsDetail,
            meta: { breadcrumb: { label: 'Mascota', dynamic: true } },
          },
          {
            path: ':petId/agregar-evaluacion/:selectedType',
            name: 'petCheckupsCreateForm',
            component: PetCheckupsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Agregar Evaluación' } },
          },
          {
            path: ':id/editar-evaluacion/:selectedType',
            name: 'petCheckupsEditForm',
            component: PetCheckupsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Editar Evaluación' } },
          },
          {
            path: ':petId/agregar-comentario',
            name: 'petCommentsCreateForm',
            component: PetCommentsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Agregar Comentario' } },
          },
          {
            path: 'editar-comentario/:id',
            name: 'petCommentsEditForm',
            component: PetCommentsForm,
            meta: { permission: 'edit_pets', breadcrumb: { label: 'Editar Comentario' } },
          },
        ]
      },

      {
        path: 'solicitudes',
        name: 'orderRequests',
        redirect: { name: 'orderRequestsIndex' },
        meta: { permission: 'view_order_requests', breadcrumb: { label: 'Solicitudes' } },
        children: [
          {
            path: '',
            name: 'orderRequestsIndex',
            component: OrderRequestsIndex,
          },
          {
            path: ':id',
            name: 'orderRequestsDetail',
            component: OrderRequestsDetail,
            meta: { breadcrumb: { label: 'Solicitud', dynamic: true } },
          }
        ]
      },

      {
        path: 'usuarios',
        name: 'users',
        redirect: { name: 'usersIndex' },
        meta: { permission: 'view_users', breadcrumb: { label: 'Usuarios' } },
        children: [
          {
            path: '',
            name: 'usersIndex',
            component: UsersIndex,
          },
          {
            path: 'crear',
            name: 'usersCreateForm',
            component: UsersForm,
            meta: { permission: 'edit_users', breadcrumb: { label: 'Crear' } },
          },
          {
            path: ':id/editar',
            name: 'usersEditForm',
            component: UsersForm,
            meta: { permission: 'edit_users', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':id',
            name: 'usersDetail',
            component: UsersDetail,
            meta: { breadcrumb: { label: 'Usuario', dynamic: true } },
          }
        ]
      },

      {
        path: 'roles',
        name: 'roles',
        redirect: { name: 'rolesIndex' },
        meta: { permission: 'view_roles', breadcrumb: { label: 'Roles' } },
        children: [
          {
            path: '',
            name: 'rolesIndex',
            component: RolesIndex,
          },
          {
            path: 'crear',
            name: 'rolesCreateForm',
            component: RolesForm,
            meta: { permission: 'edit_roles', breadcrumb: { label: 'Crear' } },
          },
          {
            path: ':id/editar',
            name: 'rolesEditForm',
            component: RolesForm,
            meta: { permission: 'edit_roles', breadcrumb: { label: 'Editar' } },
          },
          {
            path: ':id',
            name: 'rolesDetail',
            component: RolesDetail,
            meta: { breadcrumb: { label: 'Rol', dynamic: true } },
          }
        ]
      },

      {
        path: 'carrito',
        name: 'cart',
        component: Cart,
        meta: { breadcrumb: { label: 'Carrito' } },
      },

      {
        path: 'tienda',
        name: 'store',
        redirect: { name: 'productsIndex' },
        meta: { breadcrumb: { label: 'Tienda' } },
        children: [
          {
            path: 'productos',
            name: 'productsIndex',
            component: ProductsIndex
          },

          {
            path: 'producto/:id',
            name: 'productsDetail',
            component: ProductsDetail,
            meta: { breadcrumb: { label: 'Producto', dynamic: true } },
          }
        ]
      },

      {
        path: 'ordenes-compra',
        name: 'productOrders',
        redirect: { name: 'productOrdersIndex' },
        meta: { permission: 'view_product_orders', breadcrumb: { label: 'Órdenes de Compra' } },
        children: [
          {
            path: '',
            name: 'productOrdersIndex',
            component: ProductOrdersIndex
          },
          {
            path: ':id',
            name: 'productOrdersDetail',
            component: ProductOrdersDetail,
            meta: { breadcrumb: { label: 'Orden de Compra', dynamic: true } },
          },
        ]
      },

      {
        path: 'contabilidad',
        name: 'accounting',
        component: AccountingIndex,
        redirect: { name: 'incomes' },
        meta: { breadcrumb: { label: 'Contabilidad' } },
        children: [
          {
            path: 'ventas',
            name: 'incomes',
            redirect: { name: 'incomesIndex' },
            meta: { permission: 'view_incomes', breadcrumb: { label: 'Ventas' } },
            children: [
              {
                path: '',
                name: 'incomesIndex',
                component: IncomesIndex,
                meta: { permission: 'edit_incomes' },
              },
              {
                path: 'registrar',
                name: 'incomesCreateForm',
                component: IncomesForm,
                meta: { permission: 'edit_incomes', breadcrumb: { label: 'Registrar' } },
              },
              {
                path: ':id/editar',
                name: 'incomesEditForm',
                component: IncomesForm,
                meta: { permission: 'edit_incomes', breadcrumb: { label: 'Editar' } },
              },
            ]
          },
          {
            path: 'egresos',
            name: 'expenses',
            redirect: { name: 'expensesIndex' },
            meta: { permission: 'view_expenses', breadcrumb: { label: 'Egresos' } },
            children: [
              {
                path: '',
                name: 'expensesIndex',
                component: ExpensesIndex,
                meta: { permission: 'edit_expenses' },
              },
              {
                path: 'crear',
                name: 'expensesCreateForm',
                component: ExpensesForm,
                meta: { permission: 'edit_expenses', breadcrumb: { label: 'Crear' } },
              },
              {
                path: ':id/editar',
                name: 'expensesEditForm',
                component: ExpensesForm,
                meta: { permission: 'edit_expenses', breadcrumb: { label: 'Editar' } },
              },
            ]
          },
        ]
      },

      {
        path: 'reportes',
        name: 'reports',
        component: ReportsIndex,
        redirect: { name: 'biweekly' },
        meta: { permission: 'view_reports', breadcrumb: { label: 'Reportes' } },
        children: [
          {
            path: 'bisemanal',
            name: 'biweekly',
            component: Biweekly,
            meta: { breadcrumb: { label: 'Bisemanal' } },
          },
          {
            path: 'mensual',
            name: 'monthly',
            component: Monthly,
            meta: { breadcrumb: { label: 'Mensual' } },
          }
        ]
      },

      {
        path: 'manual',
        name: 'manual',
        component: ManualIndex,
        redirect: { name: 'manualGettingStarted' },
        meta: { breadcrumb: { label: 'Ayuda' } },
        children: [
          {
            path: 'primeros-pasos',
            name: 'manualGettingStarted',
            component: ManualGettingStarted,
            meta: { breadcrumb: { label: 'Primeros Pasos' } },
          },
          {
            path: 'ordenes',
            name: 'manualOrders',
            component: ManualOrders,
            meta: { breadcrumb: { label: 'Órdenes' } },
          },
          {
            path: 'produccion',
            name: 'manualProductionSchedule',
            component: ManualProductionSchedule,
            meta: { breadcrumb: { label: 'Producción' } },
          },
          {
            path: 'clientes',
            name: 'manualClients',
            component: ManualClients,
            meta: { breadcrumb: { label: 'Clientes' } },
          },
          {
            path: 'mascotas',
            name: 'manualPets',
            component: ManualPets,
            meta: { breadcrumb: { label: 'Mascotas' } },
          },
          {
            path: 'inventario',
            name: 'manualInventory',
            component: ManualInventory,
            meta: { breadcrumb: { label: 'Inventario' } },
          },
          {
            path: 'usuarios',
            name: 'manualUsers',
            component: ManualUsers,
            meta: { breadcrumb: { label: 'Usuarios' } },
          },
          {
            path: 'contabilidad',
            name: 'manualAccounting',
            component: ManualAccounting,
            meta: { breadcrumb: { label: 'Contabilidad' } },
          },
          {
            path: 'reportes-manual',
            name: 'manualReports',
            component: ManualReports,
            meta: { breadcrumb: { label: 'Reportes' } },
          }
        ]
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    component: NotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    store.commit('clearBreadcrumbLabels');
  }

  if (to.matched.some(record => record.meta.requiresLogin) && !store.state.user) {
    next({ name: 'login' });
    return;
  }

  if (to.matched.some(record => record.meta.requiresBranch) && store.state.user.franchise_user.franchise.branches.length < 1) {
    next({ name: 'login' });
    return;
  }

  if (to.matched.some(record => record.meta.permission)) {
    if (store.state.user.franchise_user.is_super) {
      next();
      return;
    }

    const requiredPermission = to.meta.permission;

    const hasPermission = store.state.user.role.permissions.some(permission => permission.slug === requiredPermission);

    if (!hasPermission) {
      next({ name: 'dashboard', params: { branchId: to.params.branchId } });
      return;
    }
  }

  if (to.params.branchId) {
    const branchIdAsInt = parseInt(to.params.branchId, 10);
    const branchIds = store.state.branches.map((branch) => branch.id);

    if (!branchIds.includes(branchIdAsInt)) {
      store.dispatch('errorSnack', 'Sucursal inválida');
      next({ name: 'dashboard', params: { branchId: branchIds[0] } });
      return;
    }
  }

  next();
});

export default router
